module.exports = __webpack_public_path__ + "static/media/WholeHomeBackup.8b7334a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/WholeHomeBackup.jpg
// module id = 3752
// module chunks = 0